import { render, staticRenderFns } from "./BulkArchive.vue?vue&type=template&id=a253ac14&"
import script from "./BulkArchive.vue?vue&type=script&lang=js&"
export * from "./BulkArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports